import { useTranslation } from "react-i18next";
import ProfileLoader from "../../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import Sponsorship from "../../../../../../components/ABOProfile/SponsorshipComponents/Sponsorship/Sponsorship";
import { LeafErrorMessage } from "../../../../../../common/leaf/LeafErrorMessage/LeafErrorMessage";
import { useGetABOProfileQuery } from "../../../../../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../../../../../store";
import defaultContent from "../../../../../../content/profile";
import "./SponsorshipTab.scss";

const SponsorshipTab = () => {
  const { t } = useTranslation(["profile"]);

  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const [aff = "", abo = ""] = affAbo.split("-");

  const { isFetching, isError, data } = useGetABOProfileQuery({
    aff,
    abo,
    ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}),
  });

  if (isFetching === true) {
    return <ProfileLoader row={1} applicant={true} isFetching={isFetching} />;
  }

  if (isError === true) {
    return <LeafErrorMessage show={isError} />;
  }

  if (data?.aboInfo) {
    const { aboInfo } = data;
    const { sponsor, platinumSponsor, fosterSponsor, internationalSponsor } = aboInfo;

    return (
      <div className="sponsorship-tab">
        <h2 className="sponsorship-tab__header">{`${t(
          "aboProfile.sponsorshipTab.sponsorshipTitle",
          defaultContent["aboProfile"]["sponsorshipTab"]["sponsorshipTitle"],
        )}`}</h2>
        <Sponsorship
          sponsor={sponsor}
          platinumSponsor={platinumSponsor}
          internationalSponsor={internationalSponsor}
          fosterSponsor={fosterSponsor}
        />
      </div>
    );
  }

  return <></>;
};

export default SponsorshipTab;
